import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Switch } from "@/components/ui/switch";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { ToggleRight } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { TID } from "@/constants/testIds";

const FEATURE_KEYS = [
  { key: "ai", label: "Inteligência Artificial" },
  { key: "appcc", label: "APPCC" },
  { key: "audits", label: "Auditorias" },
  { key: "whatsapp", label: "Notificações WhatsApp" },
  { key: "offline", label: "Modo Offline" },
  { key: "multi_unit", label: "Multi-unidade" },
  { key: "stock_control", label: "Controle de Estoque" },
];

export default function AdminFeatureFlags() {
  const [companies, setCompanies] = useState([]);
  const [selected, setSelected] = useState("");
  const [flags, setFlags] = useState({});

  // stock_control ausente = ativo (semântica do módulo Controle de Estoque)
  const normalize = (f) => ({ stock_control: true, ...(f || {}) });

  useEffect(() => {
    api.get("/admin/companies").then(({ data }) => {
      setCompanies(data);
      if (data.length && !selected) {
        setSelected(data[0].id);
        setFlags(normalize(data[0].feature_flags));
      }
    });
  }, []);

  useEffect(() => {
    const c = companies.find((x) => x.id === selected);
    if (c) setFlags(normalize(c.feature_flags));
  }, [selected, companies]);

  const save = async () => {
    try {
      await api.patch(`/admin/companies/${selected}/feature-flags`, flags);
      toast.success("Feature flags atualizadas");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha");
    }
  };

  return (
    <Layout title="Feature Flags" subtitle="Habilite ou desabilite módulos por empresa">
      <Card className="p-6 rounded-xl border-stone-200 bg-white max-w-2xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-800 font-body">Empresa</div>
        <div className="mt-2">
          <Select value={selected} onValueChange={setSelected}>
            <SelectTrigger className="bg-white" data-testid="flags-company-select">
              <SelectValue placeholder="Selecione" />
            </SelectTrigger>
            <SelectContent>
              {companies.map((c) => (
                <SelectItem key={c.id} value={c.id}>{c.trade_name || c.legal_name}</SelectItem>
              ))}
            </SelectContent>
          </Select>
        </div>

        <div className="mt-6 grid sm:grid-cols-2 gap-3">
          {FEATURE_KEYS.map((f) => (
            <label key={f.key} className="flex items-center justify-between border border-stone-200 rounded-md px-4 py-3">
              <div className="flex items-center gap-2 text-sm font-body">
                <ToggleRight className="h-4 w-4 text-emerald-800" /> {f.label}
              </div>
              <Switch
                data-testid={`flag-${f.key}`}
                checked={!!flags[f.key]}
                onCheckedChange={(v) => setFlags({ ...flags, [f.key]: v })}
              />
            </label>
          ))}
        </div>

        <Button onClick={save} className="mt-6 bg-emerald-800 hover:bg-emerald-900 text-white" disabled={!selected} data-testid={TID.companyFlagsSave}>
          Salvar
        </Button>
      </Card>
    </Layout>
  );
}
